import { getPriceFormatted, defaultPriceOptions, getEnergyEfficiencyProduct } from "@i22/rocket";
import { defineComponent } from "vue";
const ProductOfferTileMixin = defineComponent({
  props: {
    offerAlternatives: {
      type: Object,
      required: true
    },
    offerImages: {
      type: Object,
      default: () => {
      }
    },
    showAvailableVariant: {
      type: Boolean
    },
    title: {
      type: String,
      default: void 0
    }
  },
  data() {
    return {
      activeIndex: 0,
      hoverIndex: null,
      isHovered: false
    };
  },
  computed: {
    name() {
      var _a, _b;
      return this.title || ((_b = (_a = this.activeOffer) == null ? void 0 : _a.product) == null ? void 0 : _b.name) || "";
    },
    offerUrl() {
      var _a;
      return (_a = this.activeOfferVariant) == null ? void 0 : _a.path;
    },
    colorAlternatives() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.offerAlternatives) == null ? void 0 : _a.variants) == null ? void 0 : _b.COLOR) == null ? void 0 : _c.items;
    },
    activeOfferVariant() {
      if (!this.colorAlternatives)
        return void 0;
      return this.colorAlternatives[this.hoverIndex || this.activeIndex || 0] || void 0;
    },
    nextOfferIndex() {
      if (!this.colorAlternatives)
        return 0;
      return (this.activeIndex + 1) % this.colorAlternatives.length;
    },
    nextOfferVariant() {
      var _a;
      return (_a = this.colorAlternatives) == null ? void 0 : _a[this.nextOfferIndex];
    },
    activeOffer() {
      var _a;
      return (_a = this.activeOfferVariant) == null ? void 0 : _a.offer;
    },
    manualImage() {
      var _a, _b, _c;
      if (!((_b = (_a = this.activeOffer) == null ? void 0 : _a.product) == null ? void 0 : _b.articleNumber))
        return void 0;
      return ((_c = this.offerImages) == null ? void 0 : _c[this.activeOffer.product.articleNumber]) || void 0;
    },
    productImage() {
      var _a, _b, _c, _d;
      if ((_a = this.manualImage) == null ? void 0 : _a.image)
        return this.manualImage.image;
      if (((_b = this.manualImage) == null ? void 0 : _b.key) && ((_c = this.colorAlternatives) == null ? void 0 : _c[this.manualImage.key])) {
        return this.colorAlternatives[this.manualImage.key].teaserImage;
      }
      return (_d = this.activeOfferVariant) == null ? void 0 : _d.teaserImage;
    },
    productImageHover() {
      var _a, _b, _c, _d;
      if ((_a = this.manualImage) == null ? void 0 : _a.hoverImage)
        return this.manualImage.hoverImage;
      if (((_b = this.manualImage) == null ? void 0 : _b.hoverKey) && ((_c = this.colorAlternatives) == null ? void 0 : _c[this.manualImage.hoverKey])) {
        return this.colorAlternatives[this.manualImage.hoverKey].teaserImage;
      }
      return ((_d = this.nextOfferVariant) == null ? void 0 : _d.teaserImage) || this.productImage;
    },
    priceHumanized() {
      var _a;
      return getPriceFormatted(
        ((_a = this.activeOffer) == null ? void 0 : _a.prices) || [],
        "DEFAULT",
        "ONETIME",
        defaultPriceOptions
      ) || void 0;
    },
    priceWasHumanized() {
      var _a;
      return getPriceFormatted(((_a = this.activeOffer) == null ? void 0 : _a.prices) || [], "WAS", "ONETIME", defaultPriceOptions) || void 0;
    },
    energyLabel() {
      var _a;
      if (!((_a = this.activeOffer) == null ? void 0 : _a.product))
        return void 0;
      return getEnergyEfficiencyProduct(this.activeOffer.product);
    }
  },
  watch: {
    colorAlternatives: {
      handler(value) {
        var _a, _b, _c, _d;
        if (!value) {
          this.activeIndex = 0;
          return;
        }
        const activeIdx = value.findIndex(
          (item) => item.active
        ) || 0;
        if (!this.showAvailableVariant) {
          this.activeIndex = activeIdx;
          return;
        }
        const isActiveVariantAvailable = (((_d = (_c = (_b = (_a = value[activeIdx]) == null ? void 0 : _a.offer) == null ? void 0 : _b.product) == null ? void 0 : _c.availability) == null ? void 0 : _d.stock) || 0) > 0;
        this.activeIndex = Math.max(
          0,
          isActiveVariantAvailable ? activeIdx : value.findIndex(
            (item) => {
              var _a2, _b2, _c2;
              return (
                // @ts-ignore
                (((_c2 = (_b2 = (_a2 = item.offer) == null ? void 0 : _a2.product) == null ? void 0 : _b2.availability) == null ? void 0 : _c2.stock) || 0) > 0
              );
            }
          ) || 0
        );
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    resetHoverItem() {
      this.hoverIndex = null;
    },
    setHoverItem(index) {
      this.hoverIndex = index;
    },
    setActiveItemIndex(index) {
      this.activeIndex = index;
    },
    setHoverState(state) {
      this.isHovered = state;
    }
  }
});
export {
  ProductOfferTileMixin as default
};
